import { defineMessages } from "react-intl";

const messages = defineMessages({
  addActivity: {
    id: "recordCard.recordActionsBar.addActivity",
    defaultMessage: "Add Activity",
    description: "Add Activity",
  },
  addNote: {
    id: "recordCard.recordActionsBar.addNote",
    defaultMessage: "Add Note",
    description: "Add Note",
  },
  addToRoute: {
    id: "recordCard.recordActionsBar.addToRoute",
    defaultMessage: "Add to Route",
    description: "Add to Route",
  },
  call: {
    id: "recordCard.recordActionsBar.call",
    defaultMessage: "Call",
    description: "Call",
  },
  childCompanyTitle: {
    id: "recordCard.recordActionsBar.relationships.childCompanies.modal.title",
    defaultMessage: "Select Child Companies",
    description: "Title of a Select Child Companies modal iin the quick action dropdown",
  },
  companiesTitle: {
    id: "recordCard.recordActionsBar.relationships.companies.modal.title",
    defaultMessage: "Select Companies",
    description: "Title of a Select modal in the quick action dropdown",
  },
  companyTitle: {
    id: "recordCard.recordActionsBar.relationships.company.modal.title",
    defaultMessage: "Select Company",
    description: "Title of a Select modal in the quick action dropdown",
  },
  dontLogActivity: {
    id: "recordCard.recordActionsBar.dontLogActivity",
    defaultMessage: "Don’t log activity",
    description: "Don’t log activity",
  },
  edit: {
    id: "recordCard.recordActionsBar.edit",
    defaultMessage: "Edit",
    description: "Edit",
  },
  editStage: {
    id: "recordCard.recordActionsBar.editStage",
    defaultMessage: "Edit Stage",
    description: "Edit Stage",
  },
  email: {
    id: "recordCard.recordActionsBar.email",
    defaultMessage: "Email",
    description: "Email",
  },
  emailSubscribe: {
    id: "recordCard.recordActionsBar.emailSubscribe",
    defaultMessage: "Subscribe to bulk emails",
    description: "Email Subscribe",
  },
  emailUnsubscribe: {
    id: "recordCard.recordActionsBar.emailUnsubscribe",
    defaultMessage: "Unsubscribe from bulk emails",
    description: "Email Unsubscribe",
  },
  getDirections: {
    id: "recordCard.recordActionsBar.getDirections",
    defaultMessage: "Get Directions",
    description: "Get Directions",
  },
  logActivity: {
    id: "recordCard.recordActionsBar.logActivity",
    defaultMessage: "Log activity",
    description: "Log activity",
  },
  manageChildCompanies: {
    id: "recordCard.recordActionsBar.relationships.manageChildCompanies",
    defaultMessage: "Manage Child Companies",
    description: "Title of the Manage Child Companies action in Record Card's action bar",
  },
  manageCompanies: {
    id: "recordCard.recordActionsBar.relationships.manageCompanies",
    defaultMessage: "Manage Companies",
    description: "Title of the Manage Companies action in Record Card's action bar",
  },
  manageCompany: {
    id: "recordCard.recordActionsBar.relationships.manageCompany",
    defaultMessage: "Manage Company",
    description: "Title of the Manage Company action in Record Card's action bar",
  },
  manageDeals: {
    id: "recordCard.recordActionsBar.relationships.manageDeals",
    defaultMessage: "Manage Deals",
    description: "Title of the Manage Deals action in Record Card's action bar",
  },
  manageFrequencies: {
    id: "recordCard.recordActionsBar.manageFrequencies",
    defaultMessage: "Manage Frequencies",
    description: "Manage Frequencies",
  },
  manageGroups: {
    id: "recordCard.recordActionsBar.manageGroups",
    defaultMessage: "Manage Groups",
    description: "Manage Groups",
  },
  manageParentCompany: {
    id: "recordCard.recordActionsBar.relationships.manageParentCompany",
    defaultMessage: "Manage Parent Company",
    description: "Title of the Manage Parent Company action in Record Card's action bar",
  },
  managePeople: {
    id: "recordCard.recordActionsBar.relationships.managePeople",
    defaultMessage: "Manage People",
    description: "Title of the Manage Persons action in Record Card's action bar",
  },
  managePerson: {
    id: "recordCard.recordActionsBar.relationships.managePerson",
    defaultMessage: "Manage Person",
    description: "Title of the Manage Person action in Record Card's action bar",
  },
  manageRelationships: {
    id: "recordCard.recordActionsBar.manageRelationships",
    defaultMessage: "Manage Relationships",
    description: "Manage Relationships",
  },
  markLost: {
    id: "recordCard.recordActionsBar.markLost",
    defaultMessage: "Mark Lost",
    description: "Mark Lost",
  },
  markWon: {
    id: "recordCard.recordActionsBar.markWon",
    defaultMessage: "Mark Won",
    description: "Mark Won",
  },
  openCompany: {
    id: "recordCard.recordActionsBar.openCompany",
    defaultMessage: "Open Company",
    description: "Open Company",
  },
  openPerson: {
    id: "recordCard.recordActionsBar.openPerson",
    defaultMessage: "Open Person",
    description: "Open Person",
  },
  parentCompanyTitle: {
    id: "recordCard.recordActionsBar.relationships.parentCompany.modal.title",
    defaultMessage: "Select Parent Company",
    description: "Title of a Select Parent modal in the quick action dropdown",
  },
  streetView: {
    id: "recordCard.recordActionsBar.streetView",
    defaultMessage: "Street View",
    description: "Street View",
  },
  visitSite: {
    id: "recordCard.recordActionsBar.visitSite",
    defaultMessage: "Visit Site",
    description: "Visit Site",
  },
});

export default messages;
